import type { TippyProps } from './types';

export const defaultProps: TippyProps = {
    duration: [0, 0],
    ignoreAttributes: true,
    maxWidth: 600,
    placement: 'right',
};
